import {AddSpacesAt_Options, Clone, DEL, FromJSON, GetEntries, Timer, ToJSON_Advanced} from "js-vextensions";
import {Button, CheckBox, Column, Row, RowLR, Select, Spinner, Text, TextArea, TextInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {ShowMessageBox} from "react-vmessagebox";
import {ScrollView} from "react-vscrollview";
import {InfoButton, TextPlus} from "web-vcore";
import {DialogStyle} from "../../Utils/UI/GlobalStyles.js";
import {GetEffectGroupForAlarmType} from "../../Server/DB/engineConfigs/@EngineConfig/Alarms/@AlarmConfig.js";
import {SpinnerForPercent} from "../../Utils/ReactComponents/SpinnerForPercent.js";
import {PlaySound, StopSound} from "../../Utils/Bridge/Bridge_Native/MediaPlayer.js";
import {GetAudioFilesWithSubpath} from "../../Store/main/general/CacheState.js";
import _ from "lodash";
import {CycleCountType, EffectPointer, EffectPointer_UpdateRunConfigsCount, EffectPointer_ToString, EffectPointerType, NewEffectPointerBasedOnType, ResetEffectPointerBasedOnType, RunConfig, SoundMutingType, SoundPanningType, GetSoundMutingTypeDescriptions, GetSoundPanningTypeDescriptions} from "../../Server/DB/@Shared/EffectPointer.js";
import React, {useState} from "react";
import {GenerateUUID} from "mobx-graphlink";

export type EffectPointerChangerFunc = (effectPointer: EffectPointer)=>any;

export class EffectPointerInput extends BaseComponent<{enabled: boolean, value: EffectPointer, onChange: (val: EffectPointer)=>any}, {newValue: EffectPointer}> {
	ComponentWillMountOrReceiveProps(props, forMount) {
		if (forMount || props.value != this.props.value) { // if base-data changed
			this.SetState({newValue: Clone(props.value) || new EffectPointer()});
		}
	}

	render() {
		let {enabled, value, onChange} = this.props;
		value ??= new EffectPointer();

		// in the text-box, continue displaying the base-value until the user presses "OK" in the dialog
		return (
			<Row style={{flex: 1}}>
				<TextInput editable={false} style={{flex: 1}} value={EffectPointer_ToString(value)}/>
				<Button text="Effect" style={{fontSize: 12, padding: "5px 7px", borderRadius: "0 5px 5px 0"}} onClick={()=>{
					const error = null;
					let previewing_playerId: string|n;

					const ChangeDialogState = (...__)=>boxController.UpdateUI();
					const boxController = ShowMessageBox({
						title: "Edit effect-pointer", cancelButton: true,
						//messageStyle: DialogStyle({}),
						message: ()=>{
							const {newValue} = this.state;
							boxController.UpdateOptions({okButtonProps: {enabled: enabled && error == null}});
							return <EffectPointerEditor enabled={enabled} value={newValue} onChange={val=>{
								this.SetState({newValue: val});
							}}/>;
						},

						onOK: ()=>{
							// once OK is pressed, send new-value to comp's onChange, triggering base-value update for this component
							if (onChange) onChange(this.GetNewData());
						},
						onCancel: ()=>{
							this.SetState({newValue: Clone(value) || {}});
						},

						extraButtons: ()=>{
							// todo: probably add toggle for whether to play all the effects, or just do a "simple" preview (eg. ignore run-count value)
							return (
								<Row style={{display: "inline-flex", float: "right"}}>
									<Button ml={5} text={previewing_playerId != null ? "Stop" : "Preview"} onClick={async()=>{
										// "stop effect" handlers
										if (previewing_playerId != null) {
											StopSound(previewing_playerId);
											// generally redundant (due to reset after await in play-start block below), but could be useful if play-start errored
											ChangeDialogState(previewing_playerId = null);
											return;
										}

										// "start effect" handlers
										const pointer = this.GetNewData();
										if (pointer.soundFile) {
											const d = pointer.soundFile;
											const targetFile = GetAudioFilesWithSubpath(d.filePath).Random();
											if (targetFile == null) {
												ShowMessageBox({title: "Preview failed", message: "No audio-files found matching the given file-path."});
												return;
											}
											const playerId = GenerateUUID();
											ChangeDialogState(previewing_playerId = playerId);
											await PlaySound({entry: targetFile}, {
												volume: d.volume ?? 1,
												volume_evolveInterval: d.volume_evolve ? d.volume_evolveInterval : undefined,
												volume_evolveValues: d.volume_evolve ? d.volume_evolveValues : undefined,

												speed_multiplier_min: d.speed_multiplier?.min,
												speed_multiplier_max: d.speed_multiplier?.max,
												speed_duration: d.speed_duration,

												startTime_min: d.startTime?.min,
												startTime_max: d.startTime?.max,

												durationLimit: d.durationLimit,
												loop: d.loop,
												playerId,
											});
											if (previewing_playerId == playerId) {
												ChangeDialogState(previewing_playerId = null);
											}
										} else {
											ShowMessageBox({title: "Preview failed", message: "Only sound-file type is previewable atm."});
										}
									}}/>
								</Row>
							);
						},
					});
				}}/>
			</Row>
		);
	}

	GetNewData() {
		const {newValue: newData} = this.state;
		return Clone(newData) as EffectPointer;
	}
}

const splitAt = 170;

export class EffectPointerEditor extends BaseComponent<{enabled: boolean, value: EffectPointer, onChange: (newValue: EffectPointer, ui: EffectPointerEditor)=>any}, {newValue: EffectPointer, jsonError: any}> {
	ComponentWillMountOrReceiveProps(props, forMount) {
		if (forMount || props.value != this.props.value) { // if base-value changed
			this.SetState({newValue: Clone(props.value) || {}});
		}
	}

	resetErrorTimer = new Timer(5000, ()=>this.SetState({jsonError: null}), 1);
	render() {
		const {enabled, onChange} = this.props;
		const {newValue, jsonError} = this.state;

		const Change = (...__)=>{
			if (onChange) onChange(this.GetNewValue(), this);
			this.Update();
		};

		const newValueJSON_simplified = ToJSON_Advanced(newValue, {addSpacesAt: new AddSpacesAt_Options()});
		return (
			<ScrollView style={DialogStyle({width: 800})}>
				<Column>
					<Row>
						<Text>Type:</Text>
						<Select ml={5} displayType="button bar" enabled={enabled} options={GetEntries(EffectPointerType, "ui")} value={newValue.type} onChange={val=>{
							newValue.type = val;
							ResetEffectPointerBasedOnType(newValue);
							Change();
						}}/>
					</Row>

					{newValue.type == EffectPointerType.soundTag &&
					<RowLR mt={5} splitAt={splitAt}>
						<Text>Sound effect tag:</Text>
						<TextInput enabled={enabled} value={newValue.soundEffectTag} onChange={val=>Change(newValue.soundEffectTag = val)}/>
					</RowLR>}
					{newValue.type == EffectPointerType.soundFile && newValue.soundFile &&
					<>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info={`
								The sound played will be a random sound whose file-path contains the given path substring.
								Example: To find all sounds in a folder, use slashes at start and end, like: "/Alarms/LFAlarms/"
							`.AsMultiline(0)}>File path:</TextPlus>
							<TextInput enabled={enabled} value={newValue.soundFile.filePath} onChange={val=>Change(newValue.soundFile!.filePath = val)}/>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info={`
								Note: This is applied as a "multiplier" of the volume, ie. this setting does not override other volume-multipliers.
								(other multipliers include the device volume, and the current intensity of a driving entry in the Alarms comp [if applicable])
							`.AsMultiline(0)}>Volume (start):</TextPlus>
							<SpinnerForPercent min={0} enabled={enabled} value={newValue.soundFile.volume ?? 1} onChange={val=>Change(newValue.soundFile!.volume = val)}/>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info={`
								If enabled, the volume changes discretely at each interval tick during playback.
								* Interval: Seconds between each evolve-tick.
								* Values: Comma-separated percentages (0–100+) for the volume at each evolve-tick.
								* These values replace the base "Volume" setting at each evolve-tick. (start volume -> evolve #1 -> evolve #2 -> etc.)
							`.AsMultiline(0)}>Volume evolve:</TextPlus>
							<CheckBox enabled={enabled} value={newValue.soundFile.volume_evolve ?? false} onChange={val=>{
								newValue.soundFile!.volume_evolve = val || null;
								if (val) {
									newValue.soundFile!.volume_evolveInterval ??= 1;
									newValue.soundFile!.volume_evolveValues ??= [.5, 1];
								}
								Change();
							}}/>
							{newValue.soundFile.volume_evolve && <>
								<Text ml={5}>Interval:</Text>
								<Spinner ml={5} min={0.01} step={0.01} enabled={enabled} value={newValue.soundFile.volume_evolveInterval ?? 0} onChange={val=>Change(newValue.soundFile!.volume_evolveInterval = val)}/>
								<Text>s</Text>
								<CheckBox ml={5} text="Evolve across runs" enabled={enabled} value={newValue.soundFile.volume_evolveAcrossRuns ?? false} onChange={val=>Change(newValue.soundFile!.volume_evolveAcrossRuns = val || null)}/>
								<InfoButton ml={5} text={`
									If enabled, the evolve-values persist/evolve *across runs* of this effect. (within a single effect-pointer "play")
									Otherwise, the volume-evolution resets at the start of each run.
								`.AsMultiline(0)}/>
							</>}
						</RowLR>
						{newValue.soundFile.volume_evolve &&
						<RowLR mt={5} splitAt={splitAt}>
							<Text>Evolve values (%):</Text>
							<TextInput style={{flex: 1}} enabled={enabled}
								value={(newValue.soundFile.volume_evolveValues ?? []).map(v=>(v * 100).RoundTo_Str(.01)).join(", ")}
								onChange={val=>{
									const parsed = val.split(",").map(s=>parseFloat(s.trim()) / 100).filter(n=>!isNaN(n));
									Change(newValue.soundFile!.volume_evolveValues = parsed.length ? parsed : null);
								}}
							/>
							<InfoButton ml={5} text={`
							Current evolve-value count: ${(newValue.soundFile.volume_evolveValues ?? []).length}.
							Time to get to last value: ${(()=>{
								const totalSecs = (newValue.soundFile.volume_evolveInterval ?? 0) * (newValue.soundFile.volume_evolveValues?.length ?? 0);
								const mins = Math.floor(totalSecs / 60);
								const secs = (totalSecs % 60).RoundTo(1);
								return `${mins}:${String(secs).padStart(2, "0")}`;
							})()}
							`.AsMultiline(0)}/>
						</RowLR>}
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info={`
								If set, the sound will be played at a rate that achieves the given target.
								* Example 1: Multiplier of 2 means sound will be played at double speed.
								* Example 2: Duration of 10, for a 5-second sound, means sound will be played at 50% speed.
							`.AsMultiline(0)}>Speed:</TextPlus>
							<Select options={["Original", "Multiplier", "Duration"]} value={
								newValue.soundFile.speed_multiplier != null ? "Multiplier" :
								newValue.soundFile.speed_duration != null ? "Duration" :
								"Original"
							} onChange={val=>{
								if (val == "Original") {
									newValue.soundFile!.speed_multiplier = null;
									newValue.soundFile!.speed_duration = null;
								} else if (val == "Multiplier") {
									newValue.soundFile!.speed_multiplier = {min: 1, max: 1};
									newValue.soundFile!.speed_duration = null;
								} else {
									newValue.soundFile!.speed_multiplier = null;
									newValue.soundFile!.speed_duration = 1;
								}
								Change();
							}}/>
							{newValue.soundFile.speed_multiplier != null && <>
								<Text ml={5}>Min:</Text>
								<Spinner ml={5} min={0} enabled={enabled} value={newValue.soundFile.speed_multiplier?.min ?? 0} onChange={val=>{
									Change(newValue.soundFile!.speed_multiplier = {min: val, max: newValue.soundFile!.speed_multiplier?.max ?? 0});
								}}/>
								<Text ml={5}>Max:</Text>
								<Spinner ml={5} min={0} enabled={enabled} value={newValue.soundFile.speed_multiplier?.max ?? 0} onChange={val=>{
									Change(newValue.soundFile!.speed_multiplier = {min: newValue.soundFile!.speed_multiplier?.min ?? 0, max: val});
								}}/>
							</>}
							{newValue.soundFile.speed_duration != null && <Spinner ml={5} min={0} enabled={enabled} value={newValue.soundFile.speed_duration} onChange={val=>Change(newValue.soundFile!.speed_duration = val)}/>}
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info={`
								If set (ie. either min or max >0), the audio file will be played starting from a time randomly selected within the given range. (in seconds)
								Note: If min is less than 0, or max is more than audio file's duration, the range is fixed (to fit those constraints) prior to time-selection within it.
							`.AsMultiline(0)}>Start time:</TextPlus>
							<Text>Min:</Text>
							<Spinner ml={5} min={0} enabled={enabled} value={newValue.soundFile.startTime?.min ?? 0} onChange={val=>{
								Change(newValue.soundFile!.startTime = {min: val, max: newValue.soundFile!.startTime?.max ?? 0});
							}}/>
							<Text ml={5}>Max:</Text>
							<Spinner ml={5} min={0} enabled={enabled} value={newValue.soundFile.startTime?.max ?? 0} onChange={val=>{
								Change(newValue.soundFile!.startTime = {min: newValue.soundFile!.startTime?.min ?? 0, max: val});
							}}/>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info={`
								If set (ie. not -1), the audio file's playback will be stopped at the given time. (in seconds)
								For now at least, this limit is applied per audio-file play. (not per effect-pointer play -- relevant if run-count is >1)
							`.AsMultiline(0)}>Duration limit:</TextPlus>
							<Spinner min={-1} enabled={enabled} value={newValue.soundFile.durationLimit ?? -1} onChange={val=>Change(newValue.soundFile!.durationLimit = val)}/>
							<Text>s</Text>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<Text>Loop:</Text>
							<CheckBox enabled={enabled} value={newValue.soundFile.loop ?? false} onChange={val=>Change(newValue.soundFile!.loop = val)}/>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info={`
								If set to 1 or more, transcriber ignores words in filename word-group X during playback. (Example: "Group1_Group2.wav")
							`.AsMultiline(0)}>Words ignore group:</TextPlus>
							<Spinner min={0} enabled={enabled} value={newValue.soundFile.wordsIgnoreGroup ?? 0} onChange={val=>Change(newValue.soundFile!.wordsIgnoreGroup = val)}/>
						</RowLR>
					<Row mt={10} style={{fontWeight: "bold"}}>Panning</Row>
					<RowLR mt={5} splitAt={splitAt}>
						<TextPlus info={GetSoundPanningTypeDescriptions(true)}>Panning type:</TextPlus>
						<Select enabled={enabled} options={[{name: "Fallback", value: null}, ...GetEntries(SoundPanningType, "ui")]} value={newValue.soundFile.panningType} onChange={val=>Change(newValue.soundFile!.panningType = val)}/>
					</RowLR>
					{newValue.soundFile.panningType == SoundPanningType.spatial && <>
						<RowLR mt={5} splitAt={splitAt}>
							<Text>Initial direction:</Text>
							<CheckBox enabled={enabled} text="Clockwise" value={newValue.soundFile.spatial_initialDirection_clockwise ?? true} onChange={val=>Change(newValue.soundFile!.spatial_initialDirection_clockwise = val)}/>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info="Minimum interval (in seconds) before switching sound direction.">Switch-dir interval (min):</TextPlus>
							<Spinner min={0} step={0.5} enabled={enabled} value={newValue.soundFile.spatial_switchDirInterval_min ?? 3} onChange={val=>Change(newValue.soundFile!.spatial_switchDirInterval_min = val)}/>
							<Text>s</Text>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info="Maximum interval (in seconds) before switching direction of sound's movement.">Switch-dir interval (max):</TextPlus>
							<Spinner min={0} step={0.5} enabled={enabled} value={newValue.soundFile.spatial_switchDirInterval_max ?? 12} onChange={val=>Change(newValue.soundFile!.spatial_switchDirInterval_max = val)}/>
							<Text>s</Text>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<Text>Distance:</Text>
							<Spinner min={0} step={0.1} enabled={enabled} value={newValue.soundFile.spatial_distance ?? 0.3} onChange={val=>Change(newValue.soundFile!.spatial_distance = val)}/>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info="Duration in seconds for one full revolution of the sound around the listener.">Revolution duration:</TextPlus>
							<Spinner step={0.5} enabled={enabled} value={newValue.soundFile.spatial_revolutionDuration ?? 10} onChange={val=>Change(newValue.soundFile!.spatial_revolutionDuration = val)}/>
							<Text>s</Text>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info="Whether to count up or down after each cycle completion.">Cycle count type:</TextPlus>
							<Select enabled={enabled} options={GetEntries(CycleCountType, "ui")} value={newValue.soundFile.spatial_cycleComplete_countType ?? CycleCountType.none} onChange={val=>Change(newValue.soundFile!.spatial_cycleComplete_countType = val == CycleCountType.none ? null : val)}/>
						</RowLR>
						{(newValue.soundFile.spatial_cycleComplete_countType ?? CycleCountType.none) != CycleCountType.none && <>
							{newValue.soundFile.spatial_cycleComplete_countType != CycleCountType.count_down_solveTimeLeft &&
							<RowLR mt={5} splitAt={splitAt}>
								<TextPlus info="The starting count value for cycle completion announcements.">Cycle count start:</TextPlus>
								<Spinner step={1} enabled={enabled} value={newValue.soundFile.spatial_cycleComplete_countStart ?? 60} onChange={val=>Change(newValue.soundFile!.spatial_cycleComplete_countStart = val)}/>
							</RowLR>}
							<RowLR mt={5} splitAt={splitAt}>
								<TextPlus info="Volume for TTS announcements when a cycle completes.">Cycle TTS volume:</TextPlus>
								<SpinnerForPercent min={0} enabled={enabled} value={newValue.soundFile.spatial_cycleComplete_countTTSVolume ?? .1} onChange={val=>Change(newValue.soundFile!.spatial_cycleComplete_countTTSVolume = val)}/>
							</RowLR>
							<RowLR mt={5} splitAt={splitAt}>
								<TextPlus info="Whether to only make cycle-completion TTS announcements during the 'solving' phase.">Cycle TTS solving only:</TextPlus>
								<CheckBox enabled={enabled} value={newValue.soundFile.spatial_cycleComplete_countTTSInSolvingPhaseOnly ?? true} onChange={val=>Change(newValue.soundFile!.spatial_cycleComplete_countTTSInSolvingPhaseOnly = val)}/>
							</RowLR>
						</>}
					</>}
					<Row mt={10} style={{fontWeight: "bold"}}>Muting</Row>
					<RowLR mt={5} splitAt={splitAt}>
						<TextPlus info={GetSoundMutingTypeDescriptions(true)}>Muting type:</TextPlus>
						<Select enabled={enabled} options={[{name: "Fallback", value: null}, ...GetEntries(SoundMutingType, "ui")]} value={newValue.soundFile.mutingType} onChange={val=>Change(newValue.soundFile!.mutingType = val)}/>
					</RowLR>
					<Row mt={10} style={{fontWeight: "bold"}}>Multi-run</Row>
					<RowLR mt={5} splitAt={splitAt}>
						<TextPlus info={`
							How many times to select and run an audio-file matching the given criteria.
							Note: Each run can select a different file, and they are run sequentially.
							Note: If "Record session-event" is enabled, each run will also generate its own session-event.
						`.AsMultiline(0)}>Run count:</TextPlus>
						<Spinner min={1} enabled={enabled} value={newValue.soundFile.runCount ?? 1} onChange={val=>{
							const soundFile = newValue.soundFile!;
							soundFile.runCount = val;
							EffectPointer_UpdateRunConfigsCount(soundFile);
							Change();
						}}/>
						<CheckBox ml={5} text={`Run config count-override${newValue.soundFile.runConfigs_countOverride != null ? ":" : ""}`}
							value={newValue.soundFile.runConfigs_countOverride != null}
							onChange={val=>{
								if (val) {
									newValue.soundFile!.runConfigs_countOverride = newValue.soundFile!.runCount ?? 1;
								} else {
									newValue.soundFile!.runConfigs_countOverride = null;
								}
								EffectPointer_UpdateRunConfigsCount(newValue.soundFile!);
								Change();
							}}/>
						<InfoButton ml={5} text="If run-count is higher than this value, the run-configs that are defined get repeated."/>
						<Spinner ml={5} min={1} enabled={enabled && newValue.soundFile.runConfigs_countOverride != null}
							value={newValue.soundFile.runConfigs_countOverride ?? 0}
							onChange={val=>{
								newValue.soundFile!.runConfigs_countOverride = val;
								EffectPointer_UpdateRunConfigsCount(newValue.soundFile!);
								Change();
							}}/>
						</RowLR>
						<Row mt={5}>Run configs:</Row>
						{(newValue.soundFile.runConfigs ?? []).map((runConfig, index)=>{
							if (runConfig == null) return null; // just wait for user to change run-count, to fix this
							return <RunConfigEditor key={index} enabled={enabled} index={index}
								value={runConfig} onChange={val=>Change(newValue.soundFile!.runConfigs![index] = val)}/>;
						})}
					</>}
					{newValue.type == EffectPointerType.tts && newValue.tts &&
					<>
						<RowLR mt={5} splitAt={splitAt}>
							<Text>Sound tag:</Text>
							<TextInput enabled={enabled} value={newValue.tts.soundTag} onChange={val=>Change(newValue.tts!.soundTag = val)}/>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info={`
								Note: This is applied as a "multiplier" of the volume, ie. this setting does not override other volume-multipliers.
								(other multipliers include the device volume, and the current intensity of a driving entry in the Alarms comp [if applicable])
							`.AsMultiline(0)}>Volume:</TextPlus>
							<SpinnerForPercent enabled={enabled} value={newValue.tts.volume ?? 1} onChange={val=>Change(newValue.tts!.volume = val)}/>
						</RowLR>
						<RowLR mt={5} splitAt={splitAt}>
							<TextPlus info={`
								Generic macros:
								* "$rand{A|B|C}": Randomly selects one of the given substrings.
								* "$seq{A|B|C}": Selects substring at index matching current play-count (-1) during this sequence. (with wrap-around)
								Info/context:
								* Dream = Blue-tinted region on graph. (not necessarily aligned with the "dream segments" defined in journal-entry)
								* REM period = Region encompassing dreams within 30m of each other. (its "duration" is the sum of dream-durations within it)
								Session variables (only available when a live session is active):
								* $dreamN[1-9]_preGap: Gap between [dream at position N<X>] and [dream before that one]. (N1 = last, N2 = one before that, etc.)
								* $dreamN[1-9]_duration: Dream duration (in minutes) detected in dream at position N<X>.
								* $dreamDurations: Comma-separated list of all dream durations (see definition above) so far this session. (example: "45, 20, 8")
								* $dreamingTotal: Total (in minutes) of all dream-durations during this session.
								* $remN[1-9]_preGap: Gap between [REM-period at position N<X>] and [REM-period before that one]. (N1 = last, N2 = one before that, etc.)
								* $remN[1-9]_duration: Total (in minutes) of dream-durations within REM-period at position N<X>.
								* $remN[1-9]_dreams: Number of dreams within REM-period at position N<X>.
								* $remDurations: Comma-separated list of all REM durations (see definition above) so far this session. (example: "45, 20, 8")
								* $variantName: Name of the active variant (uses variant's name-for-tts if set, else the regular name).
								* $hour: The closest hour in 24h format. (eg. at 9:40am -> "10"; at 10:10pm -> "22")
								* $hourAndMinute: Current time in 24h alarm-clock format. (eg. "9:40" or "22:10")
							`.AsMultiline(0)}>Text:</TextPlus>
							<TextInput enabled={enabled} value={newValue.tts.text} onChange={val=>Change(newValue.tts!.text = val)}/>
						</RowLR>
					</>}
					{newValue.type == EffectPointerType.shakeTag &&
					<RowLR mt={5} splitAt={splitAt}>
						<Text>Shake effect tag:</Text>
						<TextInput enabled={enabled} value={newValue.shakeEffectTag} onChange={val=>Change(newValue.shakeEffectTag = val)}/>
					</RowLR>}
					{newValue.type == EffectPointerType.lightTag &&
					<RowLR mt={5} splitAt={splitAt}>
						<Text>Light effect tag:</Text>
						<TextInput enabled={enabled} value={newValue.lightEffectTag} onChange={val=>Change(newValue.lightEffectTag = val)}/>
					</RowLR>}
					{newValue.type == EffectPointerType.scriptTag &&
					<RowLR mt={5} splitAt={splitAt}>
						<Text>Script effect tag:</Text>
						<TextInput enabled={enabled} value={newValue.scriptEffectTag} onChange={val=>Change(newValue.scriptEffectTag = val)}/>
					</RowLR>}

					<Row mt={10} style={{fontWeight: "bold"}}>Others</Row>
					<Row mt={5}>
						<CheckBox text="Record session-event" enabled={enabled} value={newValue.recordSessionEvent ?? false} onChange={val=>Change(newValue.VSet("recordSessionEvent", val ? true : DEL))}/>
						<InfoButton ml={5} text={`
							If enabled, when this effect is played during a session, a session-event will be recorded for it.
							Note: Currently this only works for effects of type "sound file". (resolved file-path and start-time are included)
						`.AsMultiline(0)}/>
					</Row>
					<Row mt={5}>
						<CheckBox text="After effect:" enabled={enabled} value={newValue.afterEffect != null} onChange={val=>{
							if (val) {
								newValue.afterEffect = NewEffectPointerBasedOnType(newValue.type);
							} else {
								newValue.afterEffect = null;
								newValue.afterEffect_delay = null;
							}
							Change();
						}}/>
						<InfoButton ml={5} text={`If set, a second effect will be "chained" after this one. (only actually works for sound-file type atm)`}/>
						{newValue.afterEffect != null && <>
							<EffectPointerInput enabled={enabled} value={newValue.afterEffect} onChange={val=>Change(newValue.afterEffect = val)}/>
							<TextPlus ml={10} info={`
								Seconds to wait between the current effect (ie. the entry above) and the after-effect.
								Set to -1 to start the after-effect immediately. (ie. simultaneous with the current effect)
							`.AsMultiline(0)}>Delay:</TextPlus>
							<Spinner ml={5} enabled={enabled} value={newValue.afterEffect_delay ?? 0} onChange={val=>Change(newValue.afterEffect_delay = val || null)}/>
							<Text>s</Text>
						</>}
					</Row>

					<Text mt={10} mb={5} style={{fontWeight: "bold"}}>Raw JSON</Text>
					<TextArea enabled={enabled} autoSize={true} value={newValueJSON_simplified} onChange={val=>{
						try {
							const newData = FromJSON(val);
							Object.keys(newValue).forEach(key=>Reflect.deleteProperty(newValue, key));
							newValue.VSet(newData);
						} catch (error) {
							this.SetState({jsonError: error});
							this.resetErrorTimer.Start();
						}
						Change();
					}}/>
					{jsonError && <Text mt={5}>Error parsing JSON: {jsonError.toString()}</Text>}
				</Column>
			</ScrollView>
		);
	}

	GetNewValue() {
		const {newValue} = this.state;
		return Clone(newValue) as EffectPointer;
	}
}

export function RunConfigEditor(props: {enabled: boolean, index: number, value: RunConfig, onChange: (newValue: RunConfig)=>any}) {
	const {enabled, index, value, onChange} = props;
	const [showOverflow, setShowOverflow] = useState(false);
	const ChangeRunConfig = (changer: (val: RunConfig)=>any)=>{
		const newVal = Clone(value) as RunConfig;
		changer(newVal);
		if (!newVal.subpathInclude) delete newVal.subpathInclude;
		if (!newVal.subpathExclude) delete newVal.subpathExclude;
		if ((newVal.volumeMultiplier ?? 1) == 1) delete newVal.volumeMultiplier;
		if ((newVal.delay_post ?? 0) == 0) delete newVal.delay_post;
		onChange(newVal);
	};
	return (
		<>
			<RowLR ml={10} mt={5} splitAt={splitAt}>
				<TextPlus info={`
					If set, the audio-file selected for this run must include the given subpath. (case insensitive)
				`.AsMultiline(0)}>{index + 1}) Subpath, include:</TextPlus>
				<TextInput ml={5} enabled={enabled} value={value.subpathInclude} onChange={val=>ChangeRunConfig(a=>a.subpathInclude = val)}/>
				<TextPlus ml={5} info={`
					Note: This value does not *replace* the volume, it simply adjusts/multiplies it by X%.
				`.AsMultiline(0)}>Volume mult.:</TextPlus>
				<SpinnerForPercent ml={5} min={0} max="any" enabled={enabled} value={value.volumeMultiplier ?? 1} onChange={val=>ChangeRunConfig(a=>a.volumeMultiplier = val)}/>
				<TextPlus ml={5} info={`
					If set, a delay will be applied after this run, before the next run starts. (in seconds)
				`.AsMultiline(0)}>Post-delay:</TextPlus>
				<Spinner min={0} ml={5} step={.1} enabled={enabled} value={value.delay_post ?? 0} onChange={val=>ChangeRunConfig(a=>a.delay_post = val)}/>
				<Text>s</Text>
				<Button ml={5} size={24} mdIcon="dots-horizontal" title="More options" onClick={()=>setShowOverflow(!showOverflow)}/>
			</RowLR>
			{showOverflow &&
			<RowLR ml={10} mt={5} splitAt={splitAt}>
				<TextPlus ml={5} info={`
					If set, the audio-file selected for this run must not include the given subpath. (case insensitive)
				`.AsMultiline(0)}>Subpath, exclude:</TextPlus>
				<TextInput ml={5} enabled={enabled} value={value.subpathExclude} onChange={val=>ChangeRunConfig(a=>a.subpathExclude = val)}/>
			</RowLR>}
		</>
	);
}